export const TOPICS = 'Topics';
export const CATEGORIES = 'Categories';
export const NOW_PLAYING = 'NowPlaying';
export const RECENTS = 'Recents';
export const AUTOPLAY = 'Autoplay';
export const CARD = 'Card';
